/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputCriteriaDateComponent} from './input-criteria-date.component';
import {SelectDropdownModule} from '../shared/select-dropdown/select-dropdown.module';
import {InputModule} from '../../../input/input.module';

@NgModule({
    declarations: [
        InputCriteriaDateComponent
    ],
    exports: [
        InputCriteriaDateComponent
    ],
    imports: [
        CommonModule,
        SelectDropdownModule,
        InputModule
    ]
})
export class InputCriteriaDateModule {
}
